module.exports = __webpack_public_path__ + "static/media/Kristin Donaldson.46cfbaf2.png";